import { Department, LocationType, Position } from "types/dict";

export interface User {
  user_id: number;
  username: string;
  name: string;
  email: string;
  password: string;
  hashed_password: string;
  position: string;
  date_joined: string;
  status: boolean;
  document_approval_access: boolean;
  payment_approval_access: boolean;
  budget_access: boolean;
  role: string;
  manager_id: number;
  department_id: number;
  manager_name: string;
  locations: LocationType[];
  access_to_additional_info: boolean;
}

export const UserDefault: User = {
  user_id: 0,
  username: "",
  name: "",
  email: "",
  password: "",
  hashed_password: "",
  position: "",
  date_joined: "",
  status: false,
  document_approval_access: false,
  payment_approval_access: false,
  budget_access: false,
  role: "",
  manager_id: 0,
  department_id: 0,
  manager_name: "",
  locations: [],
  access_to_additional_info: false,
};

export interface AuthPayload {
  result: User;
  locations: LocationType[];
}

export const AuthDefault: AuthPayload = {
  result: UserDefault,
  locations: [],
};

export interface UserFilters {
  departments: Department[];
  positions: Position[];
  roles: { role: string }[];
  locations: LocationType[];
}
